import React from 'react';
import {
    Form,
    Select,
    Col,
    Row,
    message, Button,

} from 'antd';
import Cookies from 'js-cookie';
import ModalDom from '../../../../components/Modal';
import DetailTitle from '../../../../components/DetailTitle';
import { CustomRow, CustomCol } from '../../../../components/Custom';
import { post, config, postFrom } from '../../../../axios';
import {formatTime} from "../../../../utils";



const Option = Select.Option;


class Page extends React.Component {

    constructor() {
        super();
        this.state = {
            loading: false,
            merchantId:0,
            title: "租金汇集计划周期明细",
            columns:[],
            dataSource:[],
            data: {
                shortName:'',
                houseLayout: [],
                titleList: [],
            },
        }
    }

    render() {
        const modalFooter = {}
        modalFooter.footer = <Button onClick={this.handleCancel}>关闭</Button>
        let { visible, form: { getFieldDecorator, setFieldsValue } } = this.props;
        let {
            loading,
            title,
            data,
        } = this.state;
        return <ModalDom
            title={title}
            visible={visible}
            loading={loading}
            onOk={this.handleOk}
            {...modalFooter}
            onCancel={this.handleCancel}
        >
            <div className="custom">
                <Form
                    labelCol={{ span: 0 }}
                    wrapperCol={{ span: 24 }}
                >
                    <Row>
                        <Col span={24}>
                            {data.titleList ? data.titleList.map((item, index) => {
                                return (<CustomRow divider>
                                    <CustomCol label={item.value} labelStyle={{width:190,flex:"0 0 190px"}}  colStyle={{width: 240}} required={false}>
                                        {this.getDataValue(item)}
                                    </CustomCol>
                                </CustomRow>)
                            }) : null
                            }
                        </Col>
                    </Row>
                </Form>
            </div>
        </ModalDom>
    }

    componentDidMount() {
        this.props.onRef(this);
    }

    handleCancel = () => { //关闭页面
        this.props.handleCancel();
        this.setState({  loading: false, title: "租金汇集计划周期明细" });
    }
    getDataValue =({key}) =>{
        let {
            data,
        } = this.state;
        return data.dataValue[key]?data.dataValue[key]:'';
    }

    loadPack = ({ merchantId ,periods}) => {
        console.log("商户Id->"+merchantId);
        console.log("期数->"+periods);
        this.setState({ loading: false,merchantId: merchantId, title: "租金汇集计划周期明细" });
        postFrom({ url: config.API_Merchant_getCycleInfo, data: { merchantId: merchantId,periods:periods } }).then(res => {
            // const columns = res.titleList.map(e => ({title:e.value, dataIndex: e.key, render: (text, records) => this.renderRow(text, records, e)}))
            // const dataSource = res.dataValueList;
            // res.shortName=shortName;
            this.setState({ data: res, loading: false });
           // this.setState({ data: res, loading: false });
        }).catch(err => {
            message.error(err.message || '获取详情失败');
            this.setState({ loading: false });
        });

    }



    handleOk = () => {
        this.props.form.validateFieldsAndScroll((error, values) => {
            if (!error) {
                let loginData = Cookies.get('loginData');
                if (loginData) {
                    loginData = JSON.parse(loginData);
                    values.merchantId = loginData.merchantId ? loginData.merchantId : 0;
                } else {
                    message.error('未登录')
                    return
                }

                // let { data: { splitAccount } } = this.state;
                this.setState({ loading: true });
                values.firstCollectionMonth = formatTime(values._date, "YYYY-MM");
                values.merchantId= this.state.merchantId;

                // if (values.id) {
                post({ url: config.API_Merchant_updateMerchantCollectionSchedule, data: values }).then(res => {
                    message.success('操作成功');
                    this.props.handleGetList();
                    this.handleCancel();
                }).catch(err => {
                    message.error(err.message || '操作失败');
                    this.setState({ loading: false });
                })

            }
        })
    }
}

export default Form.create()(Page);


// WEBPACK FOOTER //
// ./src/page/Merchant/components/CollectionScheduleDetailedInfo/index.js